import React from 'react'
import Dropzone from 'react-dropzone'
import IconClose from "../iconComponents/IconCloseNotification";
import IconTick from "../iconComponents/IconTick";

export default function Addfiles({textStyle, attachments, uploadTitle, selectedFiles, handleDrop, removeSelectedFile, removeUploadedFile, removedFiles, maxSize, maxFiles, multiple, accept }) {
    return (
        <>
            { attachments != undefined &&
            <div >
                <ul className="dropped">
                { attachments.map((file) => {
                    let is_selected = undefined;
                    is_selected = removedFiles.find(element => element === file.id );
                    return (                      
                        <li key={file.id}>
                        {is_selected == undefined ?
                        <>
                            <a onClick={() => { removeUploadedFile(file.id) }}>
                                <IconClose className="iblock" height="14px" pathClass="g6-fill" /> &nbsp; 
                            </a>
                            <div className="iblock content1 multiline light-black">
                                <p className="iblock">{file.file_name} 
                                    <span className="light">&nbsp; saved {file.date_created} </span>
                                </p>
                                <IconTick className="iblock v-middle gap-left-xs" pathClass="ta-fill" height="13px" />
                            </div>
                        </> :
                        <>
                            <IconClose className="iblock" height="14px" pathClass="clear-fill" /> &nbsp;
                            <p className="iblock content1 light" ><span style={{textDecoration: "line-through"}}>{file.file_name} &nbsp; saved {file.date_created} </span>&nbsp; REMOVED</p>
                        </>
                        }
                        </li>
                    );
                })}
                </ul>
            </div>
            }
            <div >
                <ul className="dropped">
                    { selectedFiles.map((file) => {
                        return (                      
                            <li key={file.path}>
                                <a onClick={() => { removeSelectedFile(file.path) }}>
                                    <IconClose className="iblock" height="14px" pathClass="g6-fill" /> &nbsp;
                                </a>
                                <p className="iblock content1  multiline light-black"> {file.path} <span className="light">&nbsp; uploaded </span></p>
                                
                            </li>
                        );
                    })}
                </ul>
            </div>
            {(
                (multiple) || 
                (selectedFiles.length === 0 && attachments === undefined) ||
                (selectedFiles.length === 0 && attachments.length === 0) ||
                (removedFiles.length > 0 && removedFiles.length === attachments.length && selectedFiles.length === 0)
            ) &&
            <div>
                <Dropzone 
                    onDrop={(e) => handleDrop(e)}
                    maxSize={maxSize}
                    maxFiles={maxFiles}
                    multiple={multiple}
                    accept={accept}
                >
                {({getRootProps, getInputProps, isDragActive, isDragReject, onDropRejected, fileRejections}) => (
                    <section>
                        <div className={"boxless-drop " + (isDragReject || onDropRejected ? "tb-text "  : "p-text ") + (textStyle ? textStyle : "content2 ")} {...getRootProps()}>
                            <input {...getInputProps()} />
                            {uploadTitle}
                        </div>
                    </section>

                )}
                </Dropzone>
            </div>
            }
        </>
    )
}
